/**
 * Centralized date formatting utility
 * Format: "Aug 05, 2026"
 */
import { format, parse, isValid } from 'date-fns';

export const formatDate = (dateString) => {
    if (!dateString) return '';

    const nativeDate = new Date(dateString);

    if (!isNaN(nativeDate.getTime())) {
        return format(nativeDate, 'MMM dd, yyyy');
    }

    const parsedDate = parse(
        dateString,
        'dd-MM-yyyy HH:mm',
        new Date()
    );

    if (isValid(parsedDate)) {
        return format(parsedDate, 'MMM dd, yyyy');
    }

    return dateString;
};

// A day picked on a date picker as a calendar day (YYYY-MM-DD), the day the person picked, whatever their time zone (S-19
// (f) sub-point). toISOString, used before, turned local midnight into UTC: the day before, east of UTC.
export const toCalendarDay = (date) => (date && isValid(date) ? format(date, 'yyyy-MM-dd') : '');

// A calendar day from the server (YYYY-MM-DD) as local midnight, so a date picker shows that day in every time zone.
export const fromCalendarDay = (value) => {
    if (!value) return null;
    const day = new Date(`${String(value).slice(0, 10)}T00:00:00`);
    return isValid(day) ? day : null;
};

export default formatDate;